<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>分账结算</h1>
        <p>只对自充积分消耗计每级返佣。折扣结算、项目奖、达标奖和退款红冲还没并进结算单。15 日未确认视为认可。</p>
      </div>
      <div class="ch-actions">
        <button class="ch-btn gold" type="button" @click="syncThenGenerate">同步消耗并生成上月结算</button>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">结算单</div><div class="v">{{ list.length }}</div></div>
      <div class="ch-metric"><div class="k">应结合计</div><div class="v">¥ {{ yuan(total) }}</div></div>
      <div class="ch-metric"><div class="k">待确认</div><div class="v">{{ count('PENDING_CONFIRM') }}</div><div class="s">待复核 {{ count('CONFIRMED') }} · 待打款 {{ count('VERIFIED') }}</div></div>
    </div>
    <div class="ch-panel">
      <table class="ch-table">
        <thead><tr><th>周期</th><th>渠道</th><th>每级返佣</th><th>状态</th><th>确认截止</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>{{ row.periodMonth }}</td>
            <td>{{ nameOf(row.partnerId) }}</td>
            <td>¥ {{ yuan(row.amount) }}</td>
            <td><span class="ch-tag" :class="tagOf(row.status)">{{ statusName(row.status) }}</span></td>
            <td>{{ row.confirmDeadline || '—' }}</td>
            <td>
              <button v-if="row.status === 'CONFIRMED'" class="ch-link" type="button" @click="act(row, 'review')">复核</button>
              <button v-if="row.status === 'INVOICED'" class="ch-link" type="button" @click="act(row, 'verify')">核验</button>
              <button v-if="row.status === 'VERIFIED'" class="ch-link" type="button" @click="act(row, 'pay')">打款</button>
              <button v-if="row.status === 'PAID'" class="ch-link" type="button" @click="act(row, 'done')">完成</button>
              <span v-if="!actionable(row)">—</span>
            </td>
          </tr>
          <tr v-if="!list.length"><td colspan="6" class="ch-empty">还没有结算单</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getChannelPartners, getChannelSettlements, generateChannelSettlement, advanceChannelSettlement, syncChannelConsumption } from '@/api/admin'
import { statusName, yuan } from '../partner/labels'
import { partnerName } from './lookup'

export default {
  name: 'HqSettlements',
  data() { return { partners: [], list: [] } },
  computed: {
    total() { return this.list.reduce((n, item) => n + Number(item.amount || 0), 0) }
  },
  created() { this.load() },
  methods: {
    statusName, yuan,
    nameOf(id) { return partnerName(this.partners, id) },
    count(status) { return this.list.filter(item => item.status === status).length },
    tagOf(status) {
      if (status === 'PAID' || status === 'DONE') return 'ok'
      if (status === 'DISPUTED') return 'bad'
      return 'warn'
    },
    actionable(row) {
      return ['CONFIRMED', 'INVOICED', 'VERIFIED', 'PAID'].indexOf(row.status) >= 0
    },
    async load() {
      const partners = await getChannelPartners()
      const settlements = await getChannelSettlements()
      this.partners = partners.list || []
      this.list = settlements.list || []
    },
    async syncThenGenerate() {
      const synced = await syncChannelConsumption()
      const generated = await generateChannelSettlement()
      this.$message.success(`同步 ${synced.applied || 0} 笔，新结算单 ${generated.created || 0} 张`)
      this.load()
    },
    async act(row, action) {
      await advanceChannelSettlement(row.id, { action })
      this.$message.success('已更新')
      this.load()
    }
  }
}
</script>
